import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';

export class PasswordValidator {
  static MatchPassword(formGroup: UntypedFormGroup) {
    const password = formGroup.get('password').value;
    const confirmPassword = formGroup.get('confirmPassword').value;

    if (confirmPassword && confirmPassword !== password) {
      formGroup.get('confirmPassword').setErrors({matchPassword: true});
      // return {matchPassword: {valid: false}};
    }
    return null;
  }

  static SamePassword(formGroup: UntypedFormGroup) {
    const oldPassword = formGroup.get('currentPassword').value;
    const password = formGroup.get('password').value;

    if (oldPassword === password) {
      return {
        samePassword: {
          valid: false
        }
      };
    }
    return null;
  }

  static PasswordStrength(formControl: UntypedFormControl) {
    const regexChar = new RegExp('^.*[a-zA-Z]+.*$');
    const regexDigit = new RegExp('^.*[0-9]+.*$');

    if (!regexChar.test(formControl.value) || !regexDigit.test(formControl.value)) {
      return {passwordstrength: {valid: false}};
    }
    return null;
  }
}
